module.exports = __webpack_public_path__ + "static/img/logo.7543d15.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/logo.png
// module id = cE9S
// module chunks = 1